<div class="delete-modal">
  <div class="delete-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
      <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
      <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </svg>
  </div>

  <h4 class="delete-title">Remove From Storefront?</h4>

  <div class="delete-content">
    <p class="notice-text">
      This takes it off the Storefront and blocks new purchases. Customers who already bought it can still download it anytime.
    </p>

    <div class="btn-wrapper">
      <button type="button" class="btn btn-outline" [disabled]="isLoading" (click)="dismiss()">Cancel</button>
      <button type="button" class="btn btn-danger" [disabled]="isLoading" (click)="confirm()">
        @if (isLoading) {
          <span class="delete-modal-spinner" aria-hidden="true"></span>
        }
        Remove
      </button>
    </div>

    <label class="checkbox-wrapper">
      <input type="checkbox" [(ngModel)]="dontShowAgain">
      Don&rsquo;t show this message again
    </label>
  </div>
</div>
